import ProductTable from "./components/ProductTable";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <ProductTable />
      </div>
    </div>
  );
};

export default Tables;
